import TextInput from './TextInput'


export default TextInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/TextInput/index.js